import { faListNumeric } from '@fortawesome/free-solid-svg-icons';

const DEFAULT_STATE = {
    maximize: false, // when true, hides the app side
    activeViews: 0,
    virtualRoom: null,
    eventMap: false,
    floorplan: false,
    centerMap: null,
    externalURL: null,
    wallpaper: null,
};

export default function (state, action) {
    if (!state) {
        state = { ...DEFAULT_STATE };
    }

    switch (action.type) {
        case 'SIDEPANEL_MAXIMIZE':
            state = { ...state, maximize: action.maximize };
            break;
        case 'SIDEPANEL_TOGGLE_MAXIMIZE':
            state = { ...state, maximize: !state.maximize };
            break;
        case 'SIDEPANEL_OPEN_VIEW':
            state = {
                ...state,
                activeViews: state.activeViews + 1,
            };
            break;
        case 'SIDEPANEL_CLOSE_VIEW':
            state = {
                ...state,
                activeViews: state.activeViews - 1,
            };
            break;
        case 'SIDEPANEL_SHOW_MAP':
            state = {
                ...state,
                eventMap: action.showEventMap,
                floorplan: false,
                maximize: action.maximize ?? state.maximize,
            };
            break;
        case 'SIDEPANEL_SHOW_FLOORPLAN':
            state = {
                ...state,
                eventMap: false,
                floorplan: action.showFloorplan,
                centerMap: action.showFloorplan ? state.centerMap : null,
                maximize: action.maximize ?? state.maximize,
            };
            break;
        case 'SIDEPANEL_CENTER_MAP':
            state = {
                ...state,
                centerMap: action.coordinates,
            };
            break;
        case 'SIDEPANEL_SET_EXTERNAL_URL':
            state = {
                ...state,
                externalURL: action.url,
                virtualRoom: action.virtualRoom,
                maximize: action.url ? action.maximize : state.maximize,
            };
            break;
        case 'SIDEPANEL_IFRAME_NAVIGATION':
            state = {
                ...state,
                externalURL: action.url,
            };
            break;
        case 'SIDEPANEL_SHOW_WALLPAPER':
            state = {
                ...state,
                wallpaper: action.url,
            };
            break;
        case 'UI_NAVIGATION':
            state = {
                ...state,
                eventMap: false,
                floorplan: false,
                maximize: false,
            };
            break;
        case 'SIDEPANEL_RESET':
            state = {
                ...state,
                virtualRoom: null,
                maximize: false,
                eventMap: false,
                floorplan: false,
                centerMap: null,
                externalURL: null,
                wallpaper: null,
            };
            break;
    }

    return state;
}
